import { KeycloakConfig } from 'keycloak-js'
import { EnvironmentInterface } from './environment-interface'

const keycloakConfig: KeycloakConfig = {
  url: 'https://passport.test.tui-destiservices.com/auth',
  realm: 'one-purchasing',
  clientId: 'tcd',
}

export const environment: EnvironmentInterface = {
  appName: 'Terms Conditions Dispatcher',
  envName: 'TEST',
  production: false,
  test: true,
  i18nPrefix: '',
  keycloak: keycloakConfig,
  API_URL: 'https://tcd-ui-backend.test.tui-destiservices.com/',
  useMockData: false,
}
